module.exports = __webpack_public_path__ + "static/media/S3C1.d3d23045.svg";